import {
  checkIsSectionApplicable
} from "../entities/recording.js";
import { checkIsNotApplicableGradingValue } from "./gradingAssessmentHelpers.js";
const normalizedNodeGradingStatuses = [
  "graded",
  "applicable",
  "not_applicable",
  "insufficient_context"
];
function findBlockingAncestorSection(ancestorSectionIds, sectionGrading) {
  return ancestorSectionIds.map((sectionId) => sectionGrading?.[sectionId]).find((sectionGrade) => sectionGrade?.is_not_applicable);
}
function normalizeCriterionNodeGrading(options) {
  const { grade, ancestorSectionIds, sectionGrading } = options;
  if (!grade) {
    const blockingSection = findBlockingAncestorSection(
      ancestorSectionIds,
      sectionGrading
    );
    if (blockingSection) {
      return {
        status: "not_applicable",
        value: "N/A",
        commentary: blockingSection.commentary
      };
    }
    return {
      status: "insufficient_context",
      value: null,
      commentary: null
    };
  }
  if (checkIsNotApplicableGradingValue(grade.value)) {
    return {
      status: "not_applicable",
      value: "N/A",
      commentary: grade.commentary
    };
  }
  return {
    status: "graded",
    value: grade.value,
    commentary: grade.commentary
  };
}
function normalizeSectionNodeGrading(options) {
  const { grade, ancestorSectionIds, sectionGrading } = options;
  if (!grade) {
    const blockingSection = findBlockingAncestorSection(
      ancestorSectionIds,
      sectionGrading
    );
    if (blockingSection) {
      return {
        status: "not_applicable",
        value: "N/A",
        commentary: blockingSection.commentary
      };
    }
    return {
      status: "insufficient_context",
      value: null,
      commentary: null
    };
  }
  if (!checkIsSectionApplicable(grade)) {
    return {
      status: "not_applicable",
      value: "N/A",
      commentary: grade.commentary
    };
  }
  return {
    status: "applicable",
    value: "Applicable",
    commentary: grade.commentary
  };
}
function getNormalizedNodeGradingDisplayValue(options) {
  const { grading } = options;
  switch (grading.status) {
    case "applicable":
      return "Applicable";
    case "not_applicable":
      return "N/A";
    case "insufficient_context":
      return "Insufficient context";
    case "graded":
      return grading.value ?? "Insufficient context";
  }
}
function getNormalizedNodeGradingComparableValue(options) {
  const { gradingValueType, grading } = options;
  switch (grading.status) {
    case "applicable":
      return gradingValueType === "section" ? "a" : grading.value ?? void 0;
    case "not_applicable":
      return gradingValueType === "section" ? "n/a" : "N/A";
    case "insufficient_context":
      return void 0;
    case "graded":
      return grading.value ?? void 0;
  }
}
export {
  getNormalizedNodeGradingComparableValue,
  getNormalizedNodeGradingDisplayValue,
  normalizeCriterionNodeGrading,
  normalizeSectionNodeGrading,
  normalizedNodeGradingStatuses
};
//# sourceMappingURL=normalizedNodeGradingHelpers.js.map
